import { memo, useMemo } from 'react';
import { withNamespaces } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Alert, Button, Col, Label, Row } from 'reactstrap';

import { ROUTE_PATH_ADMIN_GUARD_CARRIER_DETAILS } from 'src/modules/3rd-party-management/constants';
import { SubcontractorVerificationStatuses } from '../../../../../constants';
import {
    buildMockSubcontractorsTableRows,
    getSubcontractorStatusMeta,
} from '../../../../../mock/subcontractors';
import SubcontractorsGraph from './SubcontractorsGraph';

const Subcontractors = ({
    t,
    supplierId,
    supplierName,
    rootSubtitle,
}) => {
    const tableRows = useMemo(
        () => buildMockSubcontractorsTableRows(supplierName || 'DACHSER SE'),
        [supplierName]
    );

    const renderStatusBadge = (statusKey) => {
        const meta = getSubcontractorStatusMeta(statusKey);
        const statusConfig = SubcontractorVerificationStatuses[statusKey]
            || SubcontractorVerificationStatuses.unknown;

        return (
            <span className={`carrier-guard-subcontractor-table-status carrier-guard-subcontractor-table-status--${statusKey}`}>
                <i className={statusConfig.icon} />
                {t(meta.title)}
            </span>
        );
    };

    return (
        <div className="carrier-guard-subcontractors-section mb-4">
            <Row className="mb-4">
                <Col sm="12">
                    <Label>
                        {t('Subcontractors')}
                    </Label>
                    <div className="table-container">
                        <table className="border-0">
                            <thead>
                                <tr>
                                    <th>{t('ID')}</th>
                                    <th>{t('Parent TP')}</th>
                                    <th>{t('Relation Type')}</th>
                                    <th>{t('Status')}</th>
                                    <th>{t('Action')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!tableRows.length && (
                                    <tr>
                                        <td colSpan={5}>
                                            <Alert className="text-center mb-0" color="warning">
                                                {t('This list is empty')}
                                            </Alert>
                                        </td>
                                    </tr>
                                )}
                                {tableRows.map((row) => (
                                    <tr key={row.id}>
                                        <td>{row.id}</td>
                                        <td>{row.parentTp}</td>
                                        <td>{t(row.relationType)}</td>
                                        <td>{renderStatusBadge(row.status)}</td>
                                        <td>
                                            <Button
                                                tag={Link}
                                                to={`${ROUTE_PATH_ADMIN_GUARD_CARRIER_DETAILS.replace(':carrierId', supplierId)}?tab=basic-information`}
                                                outline
                                                color="primary"
                                                size="sm"
                                                className="border-0"
                                            >
                                                <i className="ri-eye-line font-size-18" />
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col sm="12">
                    <Label className="mb-2">
                        {t('Subcontractor network')}
                    </Label>
                    <SubcontractorsGraph
                        rootName={supplierName || 'DACHSER'}
                        rootSubtitle={rootSubtitle || t('Logistic Company')}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default withNamespaces()(memo(Subcontractors));
